import logo from './logo.svg';
import './App.css';
import Home from './pages/Home';
import './scss/custom.scss';

function App() {
  return (
    <div>
      {' '}
      <Home />
    </div>
  );
}

export default App;
